import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-domainrecord-edit',
  templateUrl: './DomainRecordEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => DomainRecordEditComponent)}]
})
export class DomainRecordEditComponent extends BaseEditComponent {

    
    public displayDialog: boolean;
    tableName: string;
    tableAttributes: ent.TableAttribute[];

    form: FormGroup;

    @Input() public record: ent.DomainRecord;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'code' : '',
          'name' : '',
          'inactive' : '',
          'subtradeCategory' : '',
          'iei_Eligible' : '',
          'enhancedPaymentOptions' : '',
          'minimumOrderQuantityFeeCode' : '',
          'appliesToSoldTo' : '',
          'businessTypeExtension' : '',
          'authorizedMaterialList' : '',
          'drPepperAuthorizedMaterialList' : '',
          'merchLevelCode' : '',
          'offDayDeliveryFee' : '',
          'salesOfficeNumber' : '',
          'clerkCode' : '',
          'toleranceGroup' : '',
          'fountainAvailable' : '',
          'distributionChannel' : '',
          'requestReasonIDs' : '',
          'requiredAttachmentTypeIDs' : '',
          'iei_Eligibility' : '',
          'enhancedPaymentOptionsText' : '',
          'paymentEligibilityType' : '',
          'crtNumber' : '',
          'primaryGroup' : '',
          'myCokePermissions' : ''
        };
        
        this.form = fb.group(group);
        

    }


    ngOnInit(): void {
        
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        this.displayDialog = false;

    }

    showAttribute(attributeName: string): boolean {
        if (!this.tableAttributes) {
            return false;
        }
        var tableAttribute = this.tableAttributes.filter(x=>x.Attribute.Name == attributeName)[0];
        return tableAttribute !== undefined;
    }

}